import { h, Fragment } from "preact"
import { SuggestionItem } from "./SuggestionItem";

export const SuggestionList = ({suggestions, query, setQuery, setSearchSuggestion, setIsFetching}) => {
  return (
    <Fragment>
      <div class="search-drop__title h6">{ theme.suggestion_title }</div>
      <ul class="search-drop__list">
        { suggestions.map(s => (
          <SuggestionItem setQuery={ setQuery }
                          setSearchSuggestion={ setSearchSuggestion }
                          setIsFetching={ setIsFetching }
                          key={ s }
                          query={ query }
                          suggestion={ s }/>
        )) }
      </ul>
    </Fragment>
  )
}
